import React from 'react'
// import by using index.js

import {About, Contact, Footer,  Portfolio, Service} from './containers'
import {Client, Count, Navbar, Work, Home} from './components'

import './App.css'

const App = () => {
    return (
      <div className='App'>
        <div>
        <Navbar/>
        <Home/>
        </div>
        <About/>
        <Count/>
        <Service/>
        <Work/>
        <Client/>
        <Portfolio/>
        <Contact/>
        <Footer/>
      </div>
    )
  }
  
  export default App
  